import { motion } from "framer-motion";
import { fadeInUp } from "@/components/motionVariants";

export const AboutSection = () => {
  return (
    <motion.section
      id="about"
      className="py-16 md:py-24"
      data-testid="about-section"
      {...fadeInUp}
    >
      <div className="mx-auto grid max-w-md gap-10 px-6 md:max-w-4xl md:grid-cols-[1.05fr_0.95fr] md:px-12 lg:max-w-6xl">
        <div className="space-y-6">
          <p className="text-xs uppercase tracking-[0.35em] text-rose" data-testid="about-eyebrow">
            Sense Your Soul
          </p>
          <h2 className="font-serif text-3xl text-taupe md:text-4xl" data-testid="about-title">
            ที่ปรึกษาความรักส่วนตัว ไม่ใช่แค่หมอดู
          </h2>
          <p className="text-base text-taupeLight" data-testid="about-description-1">
            เราเชื่อว่าบางครั้งคำตอบไม่ได้อยู่ในไพ่ แต่อยู่ในการเข้าใจหัวใจของคุณอย่างลึกซึ้ง
            Sense Your Soul จึงเป็นพื้นที่ปลอดภัยสำหรับผู้หญิงไทยที่ต้องการความชัดเจนเรื่องความรัก
          </p>
          <p className="text-base text-taupeLight" data-testid="about-description-2">
            ด้วยความเอาใจใส่ ความสงบ และการรับฟังอย่างแท้จริง คุณจะได้เห็นเส้นทางที่ชัดเจนขึ้น
            พร้อมการสนับสนุนทางอารมณ์ที่อ่อนโยนและจริงใจ
          </p>
          <p className="italic text-sm text-taupe" data-testid="about-highlight">
            “Sometimes the answer is not in the cards, but in understanding your heart.”
          </p>
        </div>
        <div className="relative">
          <img
            src="/images/sai-tarot.jpg"
            alt="ที่ปรึกษาไพ่ทาโรต์มืออาชีพ"
            className="h-full w-full rounded-3xl object-cover shadow-soft"
            loading="lazy"
            data-testid="about-image"
          />
          <div
            className="absolute -bottom-6 -left-6 rounded-2xl bg-white/90 px-5 py-4 text-sm text-taupe shadow-soft"
            data-testid="about-badge"
          >
            รับฟังด้วยความเข้าใจ
          </div>
        </div>
      </div>
    </motion.section>
  );
};